import { useQuery } from 'react-query';
import axios from 'axios';
import { commonHeaders } from '../../constants/HeadersAPI';
import { AuthorizationAPI } from '../../constants/API';

type WorkplacesListType = {
  serviceUnitId: number;
  serviceUnitName: string;
  description?: string;
  isAvailable: boolean;
  branchName?: string;
  branchId?: number;
  queueName?: string;
  officeNumber?: number | null;
  windowNumber?: number | null;
};

const buildWorkplaceLabel = (
  workplace: WorkplacesListType,
  fallbackQueueName?: string | null
): string => {
  const serviceUnitName = workplace.serviceUnitName ?? '';
  const parsedOfficeFromName = serviceUnitName.match(/кабинет\s*(\d+)/i)?.[1] ?? '';
  const parsedWindowFromName = serviceUnitName.match(/окно\s*(\d+)/i)?.[1] ?? '';

  const branch = workplace.branchName?.trim() || '';
  const queue = workplace.queueName?.trim() || fallbackQueueName?.trim() || '';
  const office =
    workplace.officeNumber !== null && workplace.officeNumber !== undefined
      ? String(workplace.officeNumber)
      : parsedOfficeFromName;
  const window =
    workplace.windowNumber !== null && workplace.windowNumber !== undefined
      ? String(workplace.windowNumber)
      : parsedWindowFromName;

  return [
    `Филиал: ${branch || '-'}`,
    `Очередь: ${queue || '-'}`,
    `Кабинет: ${office || '-'}`,
    `Окно: ${window || '-'}`
  ].join(', ');
};

/** При передаче queue возвращаются только рабочие места с этим именем очереди (для окна оператора ?queue= в URL). */
export const useGetWorkplacesList = (queue?: string | null) => {
  const {
    data: userWorkplacesResp,
    isFetching: isLoadingUserWorkplaces,
    isSuccess: isUserWorkplacesRespRecived
  } = useQuery(
    ['userWorkplaces', queue ?? ''],
    () => {
      const params = queue?.trim() ? { queue: queue.trim() } : undefined;
      return axios.get<WorkplacesListType[]>(AuthorizationAPI.getUserWorkplaces, {
        ...commonHeaders(),
        params
      });
    },
    {
      select: ({ data }) => {
        if (data?.length) {
          return data.map((e) => ({
            label: buildWorkplaceLabel(e, queue),
            value: e.serviceUnitId,
            locked: !e.isAvailable,
            serviceUnitName: e.serviceUnitName ?? '',
            description: e.description ?? ''
          }));
        }
      }
    }
  );
  return { userWorkplacesResp, isLoadingUserWorkplaces, isUserWorkplacesRespRecived };
};
